export const resolveSellerFee = (user, auction) => {
  if (auction.type === 'autoaxess' || auction.type === 'second_chance') {
    return user.seller.fee ?? 125;
  }

  if (typeof auction.seller_fee === 'number') {
    return auction.seller_fee;
  }

  return user.seller[`${auction.type}_fee`] ?? 125;
};
